export const environment = {
  production: true
};



// WEBPACK FOOTER //
// C:/Users/s6ccq3/git/angular-three-examples/src/environments/environment.ts